export const en = {
    'normal-view-title': 'Add a second title to your ads',
    'normal-view-title-hint': 'Shown because you have ads without a second title',
    'percent-value': '{value}%',
    'popup-view-title': 'Add the second title to your ad',
    'popup-view-title-hint': 'Shown because you have an ad without the second title',
    'show-many-banner-button': 'View {count} ads',
    'show-one-banner-button': 'View {count} ad',
    'show-some-banner-button': 'View {count} ads',
    'title-extension-desc1':
        'Our data shows that the CTR of ads with the second title improves by {desktopValue} on desktops and by {mobileValue} on mobile devices.',
    'title-extension-desc2':
        'Use the second title to tell the user more about your offer. The second title is not always shown, so make sure that the ad does not lose its meaning and consistency without it.'
};
